import { useEffect, useState } from "react";
import { adminApi } from "@/lib/api";
import { ContestBoard, PointsRules } from "@/components/ContestBoard";
import { HowItWorks } from "@/components/HowItWorks";

export const StaffContests = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    const load = () => adminApi.get("/staff/contests").then(({ data }) => setItems(data)).catch(() => setItems([]));
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  return (
    <div data-testid="staff-contests" className="space-y-6">
      <div>
        <h2 className="font-display uppercase text-3xl tracking-tight">Contests</h2>
        <PointsRules />
        <p className="text-xs text-[var(--trio-muted)] mt-1">Share your QR from "My Link" and get your people scanned in at the door.</p>
      </div>
      <HowItWorks topics={["contests", "link"]} defaultOpen />
      {items?.length === 0 && <p className="text-sm text-[var(--trio-muted)]">No contests running right now. Stay ready.</p>}
      {items?.map(({ contest, standings }) => (
        <ContestBoard key={contest.id} contest={contest} standings={standings} testid={`staff-contest-${contest.id}`} />
      ))}
    </div>
  );
};
